module.exports = __webpack_public_path__ + "static/media/ng.dda0e5c8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ng.svg
// module id = 904
// module chunks = 0